import { IFeatureFlagCatalogEntry } from './feature-flag-catalog-entry.interface';

/**
 * Single source of truth for the runtime-toggleable feature flags — a curated subset of
 * the client `FeatureIdentifier` enum. Consumed by the dev-tools feature-switch page
 * (medical client) and the feature-flags admin app.
 *
 * Kept as plain string keys because the shared scope cannot import the client
 * `FeatureIdentifier` enum; a unit test in the client domain guards that every `key`
 * is a valid `FeatureIdentifier` value. `label` is the UI name (currently the key, as
 * per the Figma overview design).
 */
export const FEATURE_FLAG_CATALOG: readonly IFeatureFlagCatalogEntry[] = [
  {
    key: 'mailClientDienstkennungen',
    label: 'mailClientDienstkennungen',
    description: 'Aktivieren des Dienstkennungsdropdowns im Mail Editor (DEV-16381)',
  },
  {
    key: 'terminkalenderV3',
    label: 'terminkalenderV3',
    description: 'Aktivieren der Version V3 des Terminkalenders (DEV-16864)',
  },
  {
    key: 'heilmittelverordnung',
    label: 'heilmittelverordnung',
    description: 'Aktivieren der Heilmittelverordnung (DEV-18239/DEV-18722)',
  },
  {
    key: 'muster13Blanko',
    label: 'muster13Blanko',
    description: 'Aktivieren des Muster 13 Blankoformulars (DEV-18239/DEV-18722)',
  },
  {
    key: 'deactivateDoctor',
    label: 'deactivateDoctor',
    description: "Aktivieren von FeatureFlag 'DeactivateDoctor' (DEV-18585)",
  },
  {
    key: 'datalossWarningInDatenerfassung',
    label: 'datalossWarningInDatenerfassung',
    description: 'Aktiviert den Dialog bzgl Datenverlust in der Datenerfassung (DEV-19423)',
  },
  {
    key: 'locations',
    label: 'locations',
    description: "Aktivieren der 'Stammdaten Betriebsstätten' (Migration) (DEV-19917)",
  },
  {
    key: 'terminbestaetigung',
    label: 'terminbestaetigung',
    description: "Aktivieren von FeatureFlag 'Terminbestaetigung' (DEV-18914)",
  },
  {
    key: 'akteAttachmentsMail',
    label: 'akteAttachmentsMail',
    description: "Aktivieren von FeatureFlag 'AkteAttachmentsMail' (DEV-18911)",
  },
  {
    key: 'eigeneRegelnAuswertung',
    label: 'eigeneRegelnAuswertung',
    description: "Aktivieren von FeatureFlag 'EigeneRegelnAuswertung' (DEV-18917)",
  },
  {
    key: 'eigeneRegelnAbrechnung',
    label: 'eigeneRegelnAbrechnung',
    description: "Aktivieren von FeatureFlag 'EigeneRegelnAbrechnung' (DEV-18874)",
  },
  {
    key: 'muster7Blanko',
    label: 'muster7Blanko',
    description: 'Aktivieren des Muster 7 Blankoformulars (DEV-20480)',
  },
  {
    key: 'muster12',
    label: 'muster12',
    description: 'Aktivieren des Muster 12 Formulars (DEV-20504)',
  },
  {
    key: 'muster12Blanko',
    label: 'muster12Blanko',
    description: 'Aktivieren des Muster 12 Blankoformulars (DEV-20504)',
  },
  {
    key: 'mailversandTerminerinnerung',
    label: 'mailversandTerminerinnerung',
    description: "Aktivieren von FeatureFlag 'MailversandTerminerinnerung' (DEV-19706)",
  },
  {
    key: 'muster26',
    label: 'muster26',
    description: 'Aktivieren des Muster 26 Formulars (DEV-20621)',
  },
  {
    key: 'muster26Blanko',
    label: 'muster26Blanko',
    description: 'Aktivieren des Muster 26 Blankoformulars (DEV-20621)',
  },
  {
    key: 'tiKonfiguration',
    label: 'tiKonfiguration',
    description: 'Aktivieren der gepoolten TI-Konfiguration mit SharedTiConfiguration als Source of Truth (DEV-20455)',
  },
  {
    key: 'muster27',
    label: 'muster27',
    description: 'Aktivieren des Muster 27 Formulars (DEV-20397)',
  },
  {
    key: 'muster27Blanko',
    label: 'muster27Blanko',
    description: 'Aktivieren des Muster 27 Blankoformulars (DEV-20397)',
  },
];
